import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from 'src/environments/environment.development';
import {Archivo, Item, ItemDeleteReq} from "../interfaces/archivos.interfaces";

const apiVucUrl = environment.apiVucUrl

@Injectable({providedIn: 'root'})
export class ArchviosService {
    constructor(private http: HttpClient) {
    }

    obtenerTipos() {
        const url = apiVucUrl + `api/v1.0/archivos/tipos`
        return this.http.get<Item[]>(url, {observe: 'response'});
    }

    obtenerArchivosPorTipo(tipo: number[], desde: string, hasta: string) {
        const url = apiVucUrl + `api/v1.0/archivos/tipos/${tipo}?desde=${desde}&hasta=${hasta}`
        return this.http.get<Archivo[]>(url, {observe: 'response'});
    }

    descargarArchivo(hash: string) {
        const url = apiVucUrl + `api/v1.0/archivos/${hash}`
        return this.http.get(url, {responseType: 'blob', observe: 'response'});
    }

    eliminar(req: ItemDeleteReq) {
        return this.http.post<ItemDeleteReq>(apiVucUrl + `api/v1.0/archivos/eliminar`, req, {observe: 'response'})
    }

}
